// 建物詳細・部屋詳細
(function($){
  var target=$([]);
  $.fn.fixedSubMenu = function(expr, options) {
    options = options||{};
    target = $.merge(target, this);
    this.on("change",function(){
      if (target.filter(":checked").length === 0) {
        $(".fixed-submenu-sp").fadeIn().animate({
              bottom: '0'
            },{
              duration: 400,
              queue: false
        });
        $("#footerFixed").animate({ opacity: 0 }, { duration: 500, queue: false });
      } else {
        $(".fixed-submenu-sp").fadeOut().animate({
              bottom: '-30px'
            },{
              duration: 400,
              queue: false
        });
        $("#footerFixed").animate({ opacity: 1 }, { duration: 500, queue: false });
      }
      if (!!options.callback) options.callback.apply(this);
    });
    this.last().trigger("change");
    return this;
  }
})(jQuery);